import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { dbService } from "../services/dbService";
import homeBg from "../assets/images/home.jpeg";

export default function Survey() {
  const { t, i18n } = useTranslation("global");
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const [formData, setFormData] = useState({
    travelers: "",
    favoriteDestination: "",
    luxuryOrSpace: "luxury",
    weeksPerYear: "",
    otherMembership: "yes",
    travelMonth: "1",
    development: "development",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentUser) {
      console.error("User not authenticated");
      return;
    }

    setLoading(true);

    try {
      await dbService.saveSurveyData(currentUser.uid, formData);
      alert(t("Thanks.text"));
      navigate("/profile", { replace: true });
    } catch (error) {
      console.error("Error saving survey:", error);
      alert("Error saving survey. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex items-center justify-center w-full relative min-h-screen bg-center bg-no-repeat bg-cover py-10"
      style={{ backgroundImage: `url(${homeBg})` }}
    >
      <div className="overflow-y-auto max-h-screen bg-gray-800/50 bg-blend-multiply shadow-md rounded-lg px-8 py-8 backdrop-filter backdrop-blur-md w-full max-w-2xl mx-4">
        <h1 className="text-2xl font-bold text-center mb-4 dark:text-gray-200">
          {t("Survey.text")}
        </h1>
        <p className="border-b-2 border-gray-500"></p>
        <form onSubmit={handleSubmit}>
          <div className="pt-4 mb-4">
            <label
              htmlFor="travelers"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("FamilyTravelers.text")}
            </label>
            <input
              type="number"
              id="travelers"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.travelers}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="favoriteDestination"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("FavoriteDestination.text")}
            </label>
            <input
              type="text"
              id="favoriteDestination"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.favoriteDestination}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="luxuryOrSpace"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("LuxuryOrSpace.text")}
            </label>
            <select
              id="luxuryOrSpace"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.luxuryOrSpace}
              onChange={handleChange}
            >
              <option value="luxury">{t("Luxury.text")}</option>
              <option value="space">{t("Space.text")}</option>
            </select>
          </div>

          <div className="mb-4">
            <label
              htmlFor="weeksPerYear"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("WeeksPerYear.text")}
            </label>
            <input
              type="number"
              id="weeksPerYear"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.weeksPerYear}
              onChange={handleChange}
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="otherMembership"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("OtherMembership.text")}
            </label>
            <select
              id="otherMembership"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.otherMembership}
              onChange={handleChange}
            >
              <option value="yes">{t("Yes.text")}</option>
              <option value="no">{t("No.text")}</option>
            </select>
          </div>

          <div className="mb-4">
            <label
              htmlFor="travelMonth"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("TravelMonth.text")}
            </label>
            <select
              id="travelMonth"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.travelMonth}
              onChange={handleChange}
            >
              <option value="1">{t("January.text")}</option>
              <option value="2">{t("February.text")}</option>
              <option value="3">{t("March.text")}</option>
              <option value="4">{t("April.text")}</option>
              <option value="5">{t("May.text")}</option>
              <option value="6">{t("June.text")}</option>
              <option value="7">{t("July.text")}</option>
              <option value="8">{t("August.text")}</option>
              <option value="9">{t("September.text")}</option>
              <option value="10">{t("October.text")}</option>
              <option value="11">{t("November.text")}</option>
              <option value="12">{t("December.text")}</option>
            </select>
          </div>

          <div className="mb-4 pb-4">
            <label
              htmlFor="development"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              {t("DevelopmentOrExclusive.text")}
            </label>
            <select
              id="development"
              className="shadow-sm rounded-md w-full px-3 py-2 border-2 focus:outline-none focus:border-[#fcab21] focus:ring-[#fcab21]"
              required
              value={formData.development}
              onChange={handleChange}
            >
              <option value="development">{t("Development.text")}</option>
              <option value="exclusive">{t("Exclusive.text")}</option>
            </select>
          </div>
          <p className="border-b-2 border-gray-500"></p>
          <button
            type="submit"
            disabled={loading}
            className="mt-6 w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm text-white font-semibold bg-[#c79810] hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50"
          >
            {loading ? "Saving..." : t("Send.text")}
          </button>
        </form>
      </div>
    </div>
  );
}
